export const CurrencyCodeSymbol = {
  AF: { code: 'AFN', symbol: '؋' },
  AX: { code: 'EUR', symbol: '€' },
  AL: { code: 'ALL', symbol: 'L' },
  DZ: { code: 'DZD', symbol: 'د.ج' },
  AS: { code: 'USD', symbol: '$' },
  AD: { code: 'EUR', symbol: '€' },
  AO: { code: 'AOA', symbol: 'Kz' },
  AI: { code: 'XCD', symbol: '$' },
  AG: { code: 'XCD', symbol: '$' },
  AR: { code: 'ARS', symbol: '$' },
  AM: { code: 'AMD', symbol: '֏' },
  AW: { code: 'AWG', symbol: 'ƒ' },
  AU: { code: 'AUD', symbol: '$' },
  AT: { code: 'EUR', symbol: '€' },
  AZ: { code: 'AZN', symbol: '₼' },
  BS: { code: 'BSD', symbol: '$' },
  BH: { code: 'BHD', symbol: '.د.ب' },
  BD: { code: 'BDT', symbol: '৳' },
  BB: { code: 'BBD', symbol: '$' },
  BY: { code: 'BYR', symbol: 'Br' },
  BE: { code: 'EUR', symbol: '€' },
  BZ: { code: 'BZD', symbol: 'BZ$' },
  BJ: { code: 'XOF', symbol: 'Fr' },
  BM: { code: 'BMD', symbol: '$' },
  BT: { code: 'BTN', symbol: 'Nu.' },
  BO: { code: 'BOB', symbol: 'Bs.' },
  BA: { code: 'BAM', symbol: 'KM' },
  BW: { code: 'BWP', symbol: 'P' },
  BV: { code: 'NOK', symbol: 'kr' },
  BR: { code: 'BRL', symbol: 'R$' },
  IO: { code: 'USD', symbol: '$' },
  BN: { code: 'BND', symbol: '$' },
  BG: { code: 'BGN', symbol: 'лв' },
  BF: { code: 'XOF', symbol: 'Fr' },
  BI: { code: 'BIF', symbol: 'Fr' },
  KH: { code: 'KHR', symbol: '៛' },
  CM: { code: 'XAF', symbol: 'Fr' },
  CA: { code: 'CAD', symbol: '$' },
  CV: { code: 'CVE', symbol: 'Esc' },
  KY: { code: 'KYD', symbol: '$' },
  CF: { code: 'XAF', symbol: 'Fr' },
  TD: { code: 'XAF', symbol: 'Fr' },
  CL: { code: 'CLP', symbol: '$' },
  CN: { code: 'CNY', symbol: '¥' },
  CX: { code: 'AUD', symbol: '$' },
  CC: { code: 'AUD', symbol: '$' },
  CO: { code: 'COP', symbol: '$' },
  KM: { code: 'KMF', symbol: 'Fr' },
  CG: { code: 'XAF', symbol: 'Fr' },
  CD: { code: 'CDF', symbol: 'Fr' },
  CK: { code: 'NZD', symbol: '$' },
  CR: { code: 'CRC', symbol: '₡' },
  CI: { code: 'XOF', symbol: 'Fr' },
  HR: { code: 'HRK', symbol: 'kn' },
  CU: { code: 'CUP', symbol: '$' },
  CY: { code: 'EUR', symbol: '€' },
  CZ: { code: 'CZK', symbol: 'Kč' },
  DK: { code: 'DKK', symbol: 'kr' },
  DJ: { code: 'DJF', symbol: 'Fr' },
  DM: { code: 'XCD', symbol: '$' },
  DO: { code: 'DOP', symbol: '$' },
  EC: { code: 'USD', symbol: '$' },
  EG: { code: 'EGP', symbol: 'E£' },
  SV: { code: 'USD', symbol: '$' },
  GQ: { code: 'XAF', symbol: 'Fr' },
  ER: { code: 'ERN', symbol: 'Nfk' },
  EE: { code: 'EUR', symbol: '€' },
  ET: { code: 'ETB', symbol: 'Br' },
  FK: { code: 'FKP', symbol: '£' },
  FO: { code: 'DKK', symbol: 'kr' },
  FJ: { code: 'FJD', symbol: '$' },
  FI: { code: 'EUR', symbol: '€' },
  FR: { code: 'EUR', symbol: '€' },
  GF: { code: 'EUR', symbol: '€' },
  PF: { code: 'XPF', symbol: 'Fr' },
  TF: { code: 'EUR', symbol: '€' },
  GA: { code: 'XAF', symbol: 'Fr' },
  GM: { code: 'GMD', symbol: 'D' },
  GE: { code: 'GEL', symbol: '₾' },
  DE: { code: 'EUR', symbol: '€' },
  GH: { code: 'GHS', symbol: '₵' },
  GI: { code: 'GIP', symbol: '£' },
  GR: { code: 'EUR', symbol: '€' },
  GL: { code: 'DKK', symbol: 'kr' },
  GD: { code: 'XCD', symbol: '$' },
  GP: { code: 'EUR', symbol: '€' },
  GU: { code: 'USD', symbol: '$' },
  GT: { code: 'GTQ', symbol: 'Q' },
  GG: { code: 'GBP', symbol: '£' },
  GN: { code: 'GNF', symbol: 'Fr' },
  GW: { code: 'XOF', symbol: 'Fr' },
  GY: { code: 'GYD', symbol: '$' },
  HT: { code: 'HTG', symbol: 'G' },
  HM: { code: 'AUD', symbol: '$' },
  VA: { code: 'EUR', symbol: '€' },
  HN: { code: 'HNL', symbol: 'L' },
  HK: { code: 'HKD', symbol: '$' },
  HU: { code: 'HUF', symbol: 'Ft' },
  IS: { code: 'ISK', symbol: 'kr' },
  IN: { code: 'INR', symbol: '₹' },
  ID: { code: 'IDR', symbol: 'Rp' },
  IR: { code: 'IRR', symbol: '﷼' },
  IQ: { code: 'IQD', symbol: 'ع.د' },
  IE: { code: 'EUR', symbol: '€' },
  IM: { code: 'GBP', symbol: '£' },
  IL: { code: 'ILS', symbol: '₪' },
  IT: { code: 'EUR', symbol: '€' },
  JM: { code: 'JMD', symbol: '$' },
  JP: { code: 'JPY', symbol: '¥' },
  JE: { code: 'GBP', symbol: '£' },
  JO: { code: 'JOD', symbol: 'د.أ' },
  KZ: { code: 'KZT', symbol: '₸' },
  KE: { code: 'KES', symbol: 'Sh' },
  KI: { code: 'AUD', symbol: '$' },
  KP: { code: 'KPW', symbol: '₩' },
  KR: { code: 'KRW', symbol: '₩' },
  KW: { code: 'KWD', symbol: 'د.ك' },
  KG: { code: 'KGS', symbol: 'с' },
  LA: { code: 'LAK', symbol: '₭' },
  LV: { code: 'EUR', symbol: '€' },
  LB: { code: 'LBP', symbol: 'ل.ل' },
  LS: { code: 'LSL', symbol: 'L' },
  LR: { code: 'LRD', symbol: '$' },
  LY: { code: 'LYD', symbol: 'ل.د' },
  LI: { code: 'CHF', symbol: 'Fr' },
  LT: { code: 'LTL', symbol: 'Lt' },
  LU: { code: 'EUR', symbol: '€' },
  MO: { code: 'MOP', symbol: 'P' },
  MK: { code: 'MKD', symbol: 'ден' },
  MG: { code: 'MGA', symbol: 'Ar' },
  MW: { code: 'MWK', symbol: 'MK' },
  MY: { code: 'MYR', symbol: 'RM' },
  MV: { code: 'MVR', symbol: '.ރ' },
  ML: { code: 'XOF', symbol: 'Fr' },
  MT: { code: 'EUR', symbol: '€' },
  MH: { code: 'USD', symbol: '$' },
  MQ: { code: 'EUR', symbol: '€' },
  MR: { code: 'MRO', symbol: 'UM' },
  MU: { code: 'MUR', symbol: '₨' },
  YT: { code: 'EUR', symbol: '€' },
  MX: { code: 'MXN', symbol: '$' },
  FM: { code: 'USD', symbol: '$' },
  MD: { code: 'MDL', symbol: 'L' },
  MC: { code: 'EUR', symbol: '€' },
  MN: { code: 'MNT', symbol: '₮' },
  ME: { code: 'EUR', symbol: '€' },
  MS: { code: 'XCD', symbol: '$' },
  MA: { code: 'MAD', symbol: 'د.م.' },
  MZ: { code: 'MZN', symbol: 'MT' },
  MM: { code: 'MMK', symbol: 'Ks' },
  NA: { code: 'NAD', symbol: '$' },
  NR: { code: 'AUD', symbol: '$' },
  NP: { code: 'NPR', symbol: '₨' },
  NL: { code: 'EUR', symbol: '€' },
  NC: { code: 'XPF', symbol: 'Fr' },
  NZ: { code: 'NZD', symbol: '$' },
  NI: { code: 'NIO', symbol: 'C$' },
  NE: { code: 'XOF', symbol: 'Fr' },
  NG: { code: 'NGN', symbol: '₦' },
  NU: { code: 'NZD', symbol: '$' },
  NF: { code: 'AUD', symbol: '$' },
  MP: { code: 'USD', symbol: '$' },
  NO: { code: 'NOK', symbol: 'kr' },
  OM: { code: 'OMR', symbol: 'ر.ع.' },
  PK: { code: 'PKR', symbol: '₨' },
  PW: { code: 'USD', symbol: '$' },
  PS: { code: 'ILS', symbol: '₪' },
  PA: { code: 'PAB', symbol: 'B/.' },
  PG: { code: 'PGK', symbol: 'K' },
  PY: { code: 'PYG', symbol: '₲' },
  PE: { code: 'PEN', symbol: 'S/.' },
  PH: { code: 'PHP', symbol: '₱' },
  PN: { code: 'NZD', symbol: '$' },
  PL: { code: 'PLN', symbol: 'zł' },
  PT: { code: 'EUR', symbol: '€' },
  PR: { code: 'USD', symbol: '$' },
  QA: { code: 'QAR', symbol: 'ر.ق' },
  RE: { code: 'EUR', symbol: '€' },
  RO: { code: 'RON', symbol: 'lei' },
  RU: { code: 'RUB', symbol: '₽' },
  RW: { code: 'RWF', symbol: 'Fr' },
  SH: { code: 'SHP', symbol: '£' },
  KN: { code: 'XCD', symbol: '$' },
  LC: { code: 'XCD', symbol: '$' },
  PM: { code: 'EUR', symbol: '€' },
  VC: { code: 'XCD', symbol: '$' },
  WS: { code: 'WST', symbol: 'T' },
  SM: { code: 'EUR', symbol: '€' },
  ST: { code: 'STD', symbol: 'Db' },
  SA: { code: 'SAR', symbol: 'ر.س' },
  SN: { code: 'XOF', symbol: 'Fr' },
  RS: { code: 'RSD', symbol: 'дин.' },
  SC: { code: 'SCR', symbol: '₨' },
  SL: { code: 'SLL', symbol: 'Le' },
  SG: { code: 'SGD', symbol: '$' },
  SK: { code: 'EUR', symbol: '€' },
  SI: { code: 'EUR', symbol: '€' },
  SB: { code: 'SBD', symbol: '$' },
  SO: { code: 'SOS', symbol: 'Sh' },
  ZA: { code: 'ZAR', symbol: 'R' },
  GS: { code: 'GBP', symbol: '£' },
  SS: { code: 'SSP', symbol: '£' },
  ES: { code: 'EUR', symbol: '€' },
  LK: { code: 'LKR', symbol: 'Rs' },
  SD: { code: 'SDG', symbol: '£' },
  SR: { code: 'SRD', symbol: '$' },
  SZ: { code: 'SZL', symbol: 'L' },
  SE: { code: 'SEK', symbol: 'kr' },
  CH: { code: 'CHF', symbol: 'Fr' },
  SY: { code: 'SYP', symbol: 'ل.س' },
  TW: { code: 'TWD', symbol: '$' },
  TJ: { code: 'TJS', symbol: 'ЅМ' },
  TZ: { code: 'TZS', symbol: 'Sh' },
  TH: { code: 'THB', symbol: '฿' },
  TL: { code: 'USD', symbol: '$' },
  TG: { code: 'XOF', symbol: 'Fr' },
  TK: { code: 'NZD', symbol: '$' },
  TO: { code: 'TOP', symbol: 'T$' },
  TT: { code: 'TTD', symbol: '$' },
  TN: { code: 'TND', symbol: 'د.ت' },
  TR: { code: 'TRY', symbol: '₺' },
  TM: { code: 'TMT', symbol: 'm' },
  TC: { code: 'USD', symbol: '$' },
  TV: { code: 'AUD', symbol: '$' },
  UG: { code: 'UGX', symbol: 'Sh' },
  UA: { code: 'UAH', symbol: '₴' },
  AE: { code: 'AED', symbol: 'د.إ' },
  GB: { code: 'GBP', symbol: '£' },
  US: { code: 'USD', symbol: '$' },
  UM: { code: 'USD', symbol: '$' },
  UY: { code: 'UYU', symbol: '$' },
  UZ: { code: 'UZS', symbol: 'лв' },
  VU: { code: 'VUV', symbol: 'Vt' },
  VE: { code: 'VEF', symbol: 'Bs.F' },
  VN: { code: 'VND', symbol: '₫' },
  VG: { code: 'USD', symbol: '$' },
  VI: { code: 'USD', symbol: '$' },
  WF: { code: 'XPF', symbol: 'Fr' },
  EH: { code: 'MAD', symbol: 'د.م.' },
  YE: { code: 'YER', symbol: '﷼' },
  ZM: { code: 'ZMK', symbol: 'ZK' },
  ZW: { code: 'ZWL', symbol: '$' },
};